// extracted by css-extract-rspack-plugin
export default {"button":"BankDetailsAddNoteForm_button__4vkty","buttonWrapper":"BankDetailsAddNoteForm_buttonWrapper__gijnB","editorContainer":"BankDetailsAddNoteForm_editorContainer__d+zRX"};